import React, { useState, useEffect } from "react";
import Select from "react-select";
import { formatToZMW, rootUrl, sumOfArray } from "../../../helpers";
import { useOutletContext } from "react-router-dom";
import { useAuth } from "../../../context/auth-context";
import { FaList, FaSpinner, FaToggleOff, FaToggleOn } from "react-icons/fa";
import { FaBookJournalWhills } from "react-icons/fa6";

const CashBook = ({ startDate, endDate, triggerFetch }) => {
  const [allCash, setAllCash] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [openingBalance, setOpeningBalance] = useState(0);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [selectedCOA, setSelectedCOA] = useState(null); 
  const [selectedSOF, setSelectedSOF] = useState(null); // Add SOF filter state
  const [showDetailedView, setShowDetailedView] = useState(true);

  const [loading, setLoading] = useState(false)

  const {allData, setAllData} = useOutletContext();
  const auth = useAuth();


  const displayTable = (data, bf) => {
    let totalCredits = 0;
    let totalDebits = 0;
    let balance = bf;
    let bal = 0.0
    // Group data by COA
    const groupedData = data.reduce((acc, obj) => {
      const coa = allData.budget.find((a) => a.id === obj.coa_id)?.coa || "Unknown";
      if (!acc[coa]) acc[coa] = [];
      acc[coa].push(obj);
      return acc;
    }, {});
  
    const rows = [];
  
    Object.keys(groupedData).forEach((coa) => {
      let coaDebits = 0;
      let coaCredits = 0;
  
      // Calculate COA totals
      groupedData[coa].forEach((obj) => {
        const debit = obj.type === "income" ? parseFloat(obj.amount) : 0;
        const credit = obj.type === "expense" ? parseFloat(obj.amount) : 0;
        coaDebits += debit;
        coaCredits += credit;
        totalCredits += credit;
        totalDebits += debit;
        balance += debit - credit;
      });
  
      if (showDetailedView) {
        // Detailed transactions
        
        groupedData[coa].forEach((obj) => {
          const debit = obj.type === "income" ? parseFloat(obj.amount) : 0;
          const credit = obj.type === "expense" ? parseFloat(obj.amount) : 0;
           bal += (debit - credit)
          rows.push(
            <tr key={obj.id} className="text-center">
              {/* Transaction details */}
              <td className="px-4 py-2 border-b border-gray-300">
                {allData.budget.find((a) => a.id === obj.coa_id)?.coa}
              </td>
              <td className="px-4 py-2 border-b border-gray-300">{obj.date.substring(0, 10)}</td>
              <td className="px-4 py-2 border-b border-gray-300">{obj?.voucher}</td>
              <td className="px-4 py-2 border-b border-gray-300">{obj.cheque}</td>
              <td className="px-4 py-2 border-b border-gray-300">
                {allData?.suppliers?.find(a => a.id == obj.paye)?.name 
                }
              </td>
              <td className="px-4 py-2 border-b border-gray-300">{obj.description}</td>
              <td className="px-4 py-2 border-b border-gray-300">{formatToZMW(debit)}</td>
              <td className="px-4 py-2 border-b border-gray-300">{formatToZMW(credit)}</td>
              <td className="px-4 py-2 border-b border-gray-300">{formatToZMW(bal)}</td>
            </tr>
          );
        });
  
        // Subtotal row for detailed view
        rows.push(
          <tr key={`subtotal-${coa}`} className="bg-gray-100 ">
            <td className="px-4 py-2 border-b border-gray-300 font-bold text-left" colSpan="6">
              Subtotal for {coa} {allData.coa?.find(a=>a.account == coa)?.name}
            </td>
            <td className="px-4 py-2 border-b border-gray-300 font-bold text-right">{formatToZMW(coaDebits)}</td>
            <td className="px-4 py-2 border-b border-gray-300 font-bold text-right">{formatToZMW(coaCredits)}</td>
            <td className="px-4 py-2 border-b border-gray-300 font-bold text-right">{formatToZMW(balance)}</td>
          </tr>
        );
      } else {
        // Summary view row
        rows.push(
          <tr key={`summary-${coa}`} className="bg-gray-100">
            <td className="px-4 py-2 border-b border-gray-300 font-bold">
              {coa} {allData.coa?.find(a=>a.account == coa)?.name}
            </td>
            <td className="px-4 py-2 border-b border-gray-300 font-bold text-right">{formatToZMW(sumOfArray(allData.budget.filter(a=>a.coa == coa).map(res=>parseFloat(res.price))))}</td>
            <td className="px-4 py-2 border-b border-gray-300 font-bold text-right">{formatToZMW(coaDebits)}</td>
            <td className="px-4 py-2 border-b border-gray-300 font-bold text-right">{formatToZMW(coaCredits)}</td>
            <td className="px-4 py-2 border-b border-gray-300 font-bold text-right">
              {formatToZMW(sumOfArray(allData.budget.filter(a=>a.coa == coa).map(res=>parseFloat(res.price))) - (coaDebits - coaCredits))}
            </td>
          </tr>
        );
      }
    });
  
    // Total row
    const totals = (
      <tr className="bg-blue-950 text-white">
        <th className="px-4 py-2 border-b border-gray-300 text-left" colSpan={showDetailedView?6:1}>
          Total
        </th>
        <th className="px-4 py-2 border-b border-gray-300 text-right">{formatToZMW(sumOfArray(allData.budget.map(res=>parseFloat(res.price))))}</th>
        <th className="px-4 py-2 border-b border-gray-300 text-right">{formatToZMW(totalDebits)}</th>
        <th className="px-4 py-2 border-b border-gray-300 text-right">{formatToZMW(totalCredits)}</th>
        <th className="px-4 py-2 border-b border-gray-300 text-right">{formatToZMW(sumOfArray(allData.budget.map(res=>parseFloat(res.price))) - (totalDebits - totalCredits))}</th>
      </tr>
    );
  
    return (
      <>
        {rows}
        {showDetailedView?'':totals}
      </>
    );
  };

  // Fetch data when triggerFetch changes (triggered by button in parent)
  useEffect(() => {
    if (triggerFetch && startDate && endDate) {
      const fetchData = async () => {
        setLoading(true);
        const response = await fetch(rootUrl(`/getCashByDate/${auth.user?.cid}~${startDate}~${endDate}`));
        const result = await response.json();
        const data = result.data || [];

        setAllCash(data.cash);
        const filtered = data.cash;
        setOpeningBalance(0);
        setFilteredData(filtered);
        setLoading(false);
      };
      fetchData();
    }
  }, [triggerFetch]);

  const handleFilter = () => {
    let filtered = allCash;
    
    // Filter by COA
    if (selectedCOA && selectedCOA.value) {
      // Find all budget entries with the selected COA code
      const matchingBudget = allData.budget.filter(a => a.coa === selectedCOA.value);
      const matchingIds = matchingBudget.map(a => a.id);
      filtered = filtered.filter((item) => matchingIds.includes(item.coa_id));
    }
    
    // Filter by SOF
    if (selectedSOF && selectedSOF.value) {
      filtered = filtered.filter((item) => item.sof == selectedSOF.value);
    }
    
    setFilteredData(filtered);
  };

  // Update COA options to show both code and name
  const coaOptions = [...new Set(allData.budget.map(res => res.coa))]
    .sort()
    .map((coa) => ({
      value: coa,
      label: `${coa} - ${allData.coa.find(c => c.account === coa)?.name || ''}`,
    }));

  // Create SOF options from allData.sof
  const sofOptions = allData.sof?.map((sof) => ({
    value: sof.id,
    label: sof.name,
  })) || [];

  return (
    <div className="w-full">
      <div className="flex w-full items-center justify-between border-b pb-4">
        <div className="flex flex-col">
          <h4 className="text-[20px] text-slate-800 font-bold flex items-center"> <FaBookJournalWhills/> Ledgers</h4>
        </div>
      </div>

      <div className="flex items-center justify-between space-x-4 my-4">
        <div className="flex items-center space-x-4 my-4">
          <Select
            options={coaOptions}
            value={selectedCOA}
            onChange={(selectedOption) => setSelectedCOA(selectedOption)}
            placeholder="Select COA"
            isClearable
            className="w-64"
          />
          <Select
            options={sofOptions}
            value={selectedSOF}
            onChange={(selectedOption) => setSelectedSOF(selectedOption)}
            placeholder="Select SOF"
            isClearable
            className="w-64"
          />
          <button onClick={handleFilter} className="bg-blue-950 text-white px-4 py-2 rounded">
            Filter
          </button>
        </div>
      

        <button 
    onClick={() => setShowDetailedView(!showDetailedView)}
    className="bg-blue-950 text-white px-4 py-2 rounded"
  >
    {showDetailedView ? <FaToggleOff size={20}/> : <FaToggleOn size={20}/>}
  </button>
      </div>

      {
        loading?
        <div className='flex justify-center items-center h-full w-full text-blue-950 text-5xl p-5 m-5 '>
            <FaSpinner size={50} className="spinner"  />
        </div>
        :
        <>
         <div className="w-full gl-table table mt-5 text-[13px] rounded-b-md" title="Cash Book">
        <div id="heading">
          <span className="font-bold mb-5">
            {/* Opening balance: {formatToZMW(openingBalance)} */}
          </span>
        </div>
        <table className="table-auto w-full mt-4 border-collapse border border-gray-300 shadow-lg rounded-lg">
          <thead className="p-2">
            {
              showDetailedView?
              <tr className="bg-blue-950 text-white p-2">
              <th className="px-4 py-2 border-b border-gray-300">COA</th>
              <th className="px-4 py-2 border-b border-gray-300">Date</th>
              <th className="px-4 py-2 border-b border-gray-300">Voucher</th>
              <th className="px-4 py-2 border-b border-gray-300">Cheque</th>
              <th className="px-4 py-2 border-b border-gray-300">Payee/Payer</th>
              <th className="px-4 py-2 border-b border-gray-300">Remarks</th>
              <th className="px-4 py-2 border-b border-gray-300">Debit</th>
              <th className="px-4 py-2 border-b border-gray-300">Credit</th>
              <th className="px-4 py-2 border-b border-gray-300">Balance</th>
            </tr>
            :
            <tr className="bg-blue-950 text-white p-2">
            <th className="px-4 py-2 border-b border-gray-300 text-left">COA</th>
            <th className="px-4 py-2 border-b border-gray-300 text-right">Budgeted Amount</th>
            <th className="px-4 py-2 border-b border-gray-300 text-right">Debit</th>
            <th className="px-4 py-2 border-b border-gray-300 text-right">Credit</th>
            <th className="px-4 py-2 border-b border-gray-300 text-right">Balance</th>
          </tr>
            }
           
          </thead>
          <tbody id="trows">{displayTable(filteredData, openingBalance)}</tbody>
        </table>
      </div></>
      }
    </div>
  );
};

export default CashBook;
